import { render, staticRenderFns } from "./OtherReportsSection.vue?vue&type=template&id=5cff5b5b&"
import script from "./OtherReportsSection.vue?vue&type=script&lang=js&"
export * from "./OtherReportsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports